import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "business-free-columns-page" }
const _hoisted_2 = { class: "panel" }
const _hoisted_3 = { class: "panel__description" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "section__title" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["checked", "onChange"]
const _hoisted_8 = { class: "row__index" }
const _hoisted_9 = { class: "row__input" }
const _hoisted_10 = { class: "row__toggle" }
const _hoisted_11 = { class: "section" }
const _hoisted_12 = { class: "section__title" }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["checked", "onChange"]
const _hoisted_15 = { class: "row__index" }
const _hoisted_16 = { class: "row__input" }
const _hoisted_17 = { class: "row__toggle" }
const _hoisted_18 = { class: "actions" }

import TextButton from '@/components/input/Btn/TextButton.vue';
import ToggleSwitch from '@/corePagesModule/components/ToggleSwitch.vue';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { openConfirmModal, openFailToSavedModal, openSuccessToSaveModal } from '@/corePagesModule/components/modal/modalActions';
import { SettingRepository } from '@/coreInfrastructureModule/Repositories/SettingRepository';
import type { ApiBusinessFreeColumnSetting } from '@/coreInfrastructureModule/interfaces/ISettingRepository';
import { i18n } from '@/i18n';
import SettingsPageTitle from '@/settingsModule/components/SettingsPageTitle.vue';
import TextInput from '@/unmanagedBusinessModule/components/TextInput.vue';
import { onBeforeMount, reactive, watch } from 'vue';

const DEFAULT_HEADER_NAME_PREFIX = '自由欄';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingBusinessFreeColumnsPage',
  setup(__props) {

const t = i18n.t;
const repository = new SettingRepository();
let loadedState: ApiBusinessFreeColumnSetting | undefined;
const state = reactive<ApiBusinessFreeColumnSetting>({
  aggregate: [
    { headerName: '自由欄1', isMulti: false, isConfigured: false },
    { headerName: '自由欄2', isMulti: false, isConfigured: false },
    { headerName: '自由欄3', isMulti: false, isConfigured: false },
  ],
  base: [
    { headerName: '自由欄1', isMulti: false, isConfigured: false },
    { headerName: '自由欄2', isMulti: false, isConfigured: false },
    { headerName: '自由欄3', isMulti: false, isConfigured: false },
  ],
});

/**
 * 自由欄設定をコピーする
 * @param setting - コピー元の自由欄設定
 */
const cloneSetting = (setting: ApiBusinessFreeColumnSetting): ApiBusinessFreeColumnSetting => ({
  aggregate: setting.aggregate.map((item) => ({ ...item })),
  base: setting.base.map((item) => ({ ...item })),
});

/**
 * 読み込み時点で有効だった自由欄が無効化されたかどうかを判定する
 */
const hasDisabledConfiguredColumn = () => {
  if (!loadedState) return false;
  const snapshot = loadedState;
  return (
    snapshot.aggregate.some((item, index) => item.isConfigured && !state.aggregate[index]?.isConfigured) ||
    snapshot.base.some((item, index) => item.isConfigured && !state.base[index]?.isConfigured)
  );
};

/**
 * 自由欄設定を読み込む
 */
const loadSetting = async () => {
  const result = await waitLoading(repository.getBusinessFreeColumnSetting());
  if (!result || result.status.type !== 'success') return;
  state.aggregate = result.status.data.aggregate;
  state.base = result.status.data.base;
  loadedState = cloneSetting(result.status.data);
};

/**
 * 自由欄設定を保存する
 */
const saveSetting = async () => {
  if (hasDisabledConfiguredColumn()) {
    const confirmResult = await openConfirmModal(
      'warning',
      t('自由欄を無効化しますか'),
      t('削除して保存'),
      t('キャンセル'),
      t('無効化した自由欄の入力済みデータも削除されます。')
    );
    if (!confirmResult.isConfirmed) return;
  }

  const result = await waitLoading(repository.putBusinessFreeColumnSetting({ aggregate: state.aggregate, base: state.base }));
  if (result?.status.type === 'success') {
    loadedState = cloneSetting(state);
    await openSuccessToSaveModal();
  } else {
    await openFailToSavedModal();
  }
};

onBeforeMount(loadSetting);

watch(
  () => i18n.locale,
  () => {
    state.aggregate.forEach((column, index) => {
      if (!column.isConfigured) {
        column.headerName = `${t(DEFAULT_HEADER_NAME_PREFIX)}${index + 1}`;
      }
    });
    state.base.forEach((column, index) => {
      if (!column.isConfigured) {
        column.headerName = `${t(DEFAULT_HEADER_NAME_PREFIX)}${index + 1}`;
      }
    });
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(SettingsPageTitle, {
      label: _unref(t)('設定 > 自由欄カラム')
    }, null, 8, ["label"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('組織で利用する自由欄のヘッダー名と複数選択設定を管理します')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(t)('仕入取引に関する項目を追加')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.aggregate, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `aggregate-${index}`,
            class: "row"
          }, [
            _createElementVNode("label", {
              class: "row__check",
              title: _unref(t)('使用')
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "row__check-input",
                checked: item.isConfigured,
                onChange: (event) => (item.isConfigured = (event.target as HTMLInputElement).checked)
              }, null, 40, _hoisted_7)
            ], 8, _hoisted_6),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('ヘッダー名')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(TextInput, {
                "model-value": item.headerName,
                label: "",
                disabled: !item.isConfigured,
                "onUpdate:modelValue": (value) => (item.headerName = value)
              }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(ToggleSwitch, {
                "is-enabled": item.isMulti,
                disabled: !item.isConfigured,
                onOnToggled: (value) => (item.isMulti = value)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('複数選択')), 1)
                ], undefined, true),
                _: 2
              }, 1032, ["is-enabled", "disabled", "onOnToggled"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(t)('販売取引に関する項目を追加')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.base, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `base-${index}`,
            class: "row"
          }, [
            _createElementVNode("label", {
              class: "row__check",
              title: _unref(t)('使用')
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "row__check-input",
                checked: item.isConfigured,
                onChange: (event) => (item.isConfigured = (event.target as HTMLInputElement).checked)
              }, null, 40, _hoisted_14)
            ], 8, _hoisted_13),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('ヘッダー名')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(TextInput, {
                "model-value": item.headerName,
                label: "",
                disabled: !item.isConfigured,
                "onUpdate:modelValue": (value) => (item.headerName = value)
              }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(ToggleSwitch, {
                "is-enabled": item.isMulti,
                disabled: !item.isConfigured,
                onOnToggled: (value) => (item.isMulti = value)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('複数選択')), 1)
                ], undefined, true),
                _: 2
              }, 1032, ["is-enabled", "disabled", "onOnToggled"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(TextButton, { onClick: saveSetting }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
          ], undefined, true),
          _: 1
        })
      ])
    ])
  ]))
}
}

})